import { Collapse, Grid } from "@mui/material";
import React from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { useQueryClient } from "react-query";
import { LAT_LNG } from "../../../config/cacheKey";
export default function SupplierMap(props: any) {
  const queryClient = useQueryClient();
  const getLAT_LNG = (lat: number, lng: number) => {
    queryClient.setQueryData(LAT_LNG, [10, 20]);
    props.setFlyToLoc({ lat, lng });
  };
  return (
    <>
      {props.openCollapseCity ? (
        <Collapse
          in={props.openCollapseSupp}
          sx={{ width: "100%", fontSize: "11px" }}
        >
          <Grid
            className="borderBottomDrawer mbottom13 borderBeforSupp textFont13 cursorPointer"
            container
            spacing={2}
            item
            xs={12}
            onClick={() => getLAT_LNG(props.supp.lat, props.supp.lng)}
          >
            <Grid item xs={5} className="centerDrawerMapSupp">
              <span style={{ color: "#73D9C4" }}>
                &nbsp;
                {props.supp.supplierTitle}
              </span>
            </Grid>
            <Grid item xs={6} className="centerDrawerMapSupp">
              <span style={{ color: "#fff" }}>
                {" "}
                تعداد:&nbsp;{props.supp.count} | مبلغ:{" "}
                {props.supp.amount.toLocaleString("fa")} ریال
              </span>
            </Grid>
            {/* <Grid item xs={2}>
          {props.openCollapseSupp ? (
            <ArrowDropDownIcon></ArrowDropDownIcon>
          ) : (
            <ArrowLeftIcon></ArrowLeftIcon>
          )}
        </Grid> */}
          </Grid>
        </Collapse>
      ) : null}
    </>
  );
}
